<template>
  <!-- <div class="problem-report-container" :style="{ backgroundColor: bgColor }"> -->
    <div class="problem-report-card">
      <h2 class="report-title">Report a Problem</h2>
      
      <form @submit.prevent="handleSubmit" class="report-form">
        <!-- Route Input -->
        <div class="form-group">
          <label for="route">Page/Route where issue occurred</label>
          <input
            id="route"
            v-model="formData.route"
            type="text"
            placeholder="e.g., /dashboard/analytics"
            required
          />
        </div>

        <!-- Anonymous Toggle -->
        <div class="form-group anonymous-toggle">
          <label>
            <input
              type="checkbox"
              v-model="formData.isAnonymous"
              @change="toggleAnonymous"
            />
            <span class="toggle-slider"></span>
            Submit anonymously
          </label>
        </div>

        <!-- User ID (hidden when anonymous) -->
        <div class="form-group" v-if="!formData.isAnonymous">
          <label for="userId">User Name</label>
          <input
            id="userId"
            v-model="formData.userId"
            type="text"
            placeholder="Your user Name"
            required
          />
        </div>

        <!-- Issue Description -->
        <div class="form-group">
          <label for="issue">Issue Description</label>
          <textarea
            id="issue"
            v-model="formData.issue"
            rows="4"
            placeholder="Describe the problem in detail..."
            required
          ></textarea>
        </div>

        <!-- Priority Level -->
        <div class="form-group">
          <label>Priority Level</label>
          <div class="priority-options">
            <button
              v-for="level in priorityLevels"
              :key="level.value"
              type="button"
              :class="{
                'priority-btn': true,
                'active': formData.priority === level.value,
                [level.value]: true
              }"
              @click="formData.priority = level.value"
            >
              {{ level.label }}
            </button>
          </div>
        </div>

        <!-- Category -->
        <div class="form-group">
          <label for="category">Category</label>
          <select id="category" v-model="formData.category" required>
            <option value="" disabled>Select a category</option>
            <option v-for="cat in categories" :key="cat.value" :value="cat.value">
              {{ cat.label }}
            </option>
          </select>
        </div>

        <!-- Additional Comments -->
        <div class="form-group">
          <label for="comments">Additional Comments</label>
          <textarea
            id="comments"
            v-model="formData.comments"
            rows="3"
            placeholder="Any additional information..."
          ></textarea>
        </div>

        <!-- Screenshot Upload -->
        <div class="form-group">
          <label for="screenshot">Attach Screenshot (Optional)</label>
          <div class="file-upload">
            <input
              type="file"
              id="screenshot"
              accept="image/*"
              @change="handleFileUpload"
              ref="fileInput"
            />
            <label for="screenshot" class="upload-btn">
              <span v-if="!formData.screenshot">Choose File</span>
              <span v-else>{{ formData.screenshot.name }}</span>
            </label>
            <button
              v-if="formData.screenshot"
              type="button"
              class="clear-btn"
              @click="clearFile"
            >
              Clear
            </button>
          </div>
          <div v-if="filePreview" class="file-preview">
            <img :src="filePreview" alt="Preview" />
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button type="button" class="cancel-btn" @click="resetForm">
            Cancel
          </button>
          <button type="submit" class="submit-btn" @click="submitReport()">Submit Report</button>
        </div>
      </form>
    </div>

    <!-- Success Modal -->
    <div v-if="showSuccessModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Report Submitted Successfully!</h3>
          <button @click="showSuccessModal = false" class="modal-close">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <p>Thank you for your feedback. We'll review your report shortly.</p>
          <p>Reference ID: {{ submissionRef }}</p>
        </div>
        <div class="modal-footer">
          <button @click="showSuccessModal = false" class="modal-ok-btn">
            OK
          </button>
        </div>
      </div>
    </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'ProblemReport',
  data() {
    return {
      bgColor: '#6e8efb',
      formData: {
        route: '',
        isAnonymous: false,
        userId: '',
        issue: '',
        priority: 'normal',
        category: '',
        comments: '',
        screenshot: null
      },
      priorityLevels: [
        { value: 'low', label: 'Low' },
        { value: 'normal', label: 'Normal' },
        { value: 'high', label: 'High' },
        { value: 'critical', label: 'Critical' }
      ],
      categories: [
        { value: 'ui', label: 'UI/UX' },
        { value: 'processing', label: 'Processing' },
        { value: 'backend', label: 'Backend' },
        { value: 'data', label: 'Data' },
        { value: 'accuracy', label: 'Accuracy' },
        { value: 'performance', label: 'Performance' },
        { value: 'other', label: 'Other' }
      ],
      filePreview: null,
      showSuccessModal: false,
      submissionRef: '',

      devConsole:false
    }
  },
  created() {
    this.formData.route = window.location.pathname;
    // this.formData.userId = 'user_' + Math.random().toString(36).substr(2, 9);
  },
  methods: {
    toggleAnonymous() {
      if (this.formData.isAnonymous) {
        this.formData.userId = 'anonymous';
      } else {
        this.formData.userId = 'user_' + Math.random().toString(36).substr(2, 9);
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.formData.screenshot = file;
        this.previewFile(file);
      }
    },
    previewFile(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.filePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    clearFile() {
      this.formData.screenshot = null;
      this.filePreview = null;
      this.$refs.fileInput.value = '';
    },
    resetForm() {
      this.formData = {
        route: window.location.pathname,
        isAnonymous: false,
        userId: 'user_' + Math.random().toString(36).substr(2, 9),
        issue: '',
        priority: 'normal',
        category: '',
        comments: '',
        screenshot: null
      };
      this.filePreview = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    async handleSubmit() {
      try {
        // In a real app, you would send this to your backend
        this.devConsole && console.log('Submitting report:', btoa(JSON.stringify(this.formData)));
        
        // Generate a reference ID
        this.submissionRef = 'REF-' + Math.random().toString(36).substr(2, 8).toUpperCase();
        
        // Show success modal
        this.showSuccessModal = true;
        
        // Reset form after submission
        window.location.href = `https://wa.me/+94774690541?text=${btoa(JSON.stringify(this.formData))}`;

        this.resetForm();
      } catch (error) {
        this.devConsole && console.error('Error submitting report:', error);
        // You would show an error message to the user in a real app
      }
    },submitReport(){
      // console.log(this.formData)
      JSON.stringify(btoa(this.formData))
    }
  }
}
</script>

<style scoped>
.problem-report-container {
  min-height: calc(100vh - 100px);
  display: flex;
  justify-content: center;
  align-items: flex-start; 
  padding: 20px;
  background-color: #f5f7fa;
  transition: background-color 0.3s ease;
}

.problem-report-card {
  width: 100%;
  max-width: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin: 20px 0; 
}

.report-title {
  color: #2c3e50;
  margin-bottom: 25px;
  text-align: center;
  font-weight: 600;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #34495e;
}

.form-group input[type="text"],
.form-group input[type="email"],
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s;
}

.form-group input[type="text"]:focus,
.form-group input[type="email"]:focus,
.form-group textarea:focus,
.form-group select:focus {
  border-color: #6e8efb;
  box-shadow: 0 0 0 3px rgba(110, 142, 251, 0.2);
  outline: none;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.priority-options {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.priority-btn {
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 500;
}

.priority-btn:hover {
  transform: translateY(-2px);
}

.priority-btn.active {
  color: white;
  border-color: transparent;
}

.priority-btn.low.active {
  background-color: #2ecc71;
}

.priority-btn.normal.active {
  background-color: #3498db;
}

.priority-btn.high.active {
  background-color: #f39c12;
}

.priority-btn.critical.active {
  background-color: #e74c3c;
}

.anonymous-toggle {
  display: flex;
  align-items: center;
}

.anonymous-toggle label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.anonymous-toggle input[type="checkbox"] {
  display: none;
}

.toggle-slider {
  width: 50px;
  height: 24px;
  background-color: #ddd;
  border-radius: 12px;
  position: relative;
  margin-right: 10px;
  transition: background-color 0.3s;
}

.toggle-slider:before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  top: 2px;
  left: 2px;
  transition: transform 0.3s;
}

.anonymous-toggle input[type="checkbox"]:checked + .toggle-slider {
  background-color: #6e8efb;
}

.anonymous-toggle input[type="checkbox"]:checked + .toggle-slider:before {
  transform: translateX(26px);
}

.file-upload {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-upload input[type="file"] {
  display: none;
}

.upload-btn {
  padding: 10px 15px;
  background-color: #f8f9fa;
  border: 1px dashed #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  flex-grow: 1;
  text-align: center;
}

.upload-btn:hover {
  background-color: #e9ecef;
  border-color: #6e8efb;
}

.clear-btn {
  padding: 10px 15px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.clear-btn:hover {
  background-color: #e9ecef;
  border-color: #e74c3c;
  color: #e74c3c;
}

.file-preview {
  margin-top: 10px;
}

.file-preview img {
  max-width: 100%;
  max-height: 200px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
}

.cancel-btn, .submit-btn {
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
}

.cancel-btn {
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  color: #34495e;
}

.cancel-btn:hover {
  background-color: #e9ecef;
}

.submit-btn {
  background-color: #6e8efb;
  border: 1px solid #6e8efb;
  color: white;
}

.submit-btn:hover {
  background-color: #5a7df4;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(110, 142, 251, 0.3);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.modal-header {
  padding: 20px;
  background-color: #6e8efb;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0 10px;
}

.modal-body {
  padding: 20px;
  color: #34495e;
}

.modal-footer {
  padding: 15px 20px;
  display: flex;
  justify-content: flex-end;
  background-color: #f8f9fa;
}

.modal-ok-btn {
  padding: 10px 20px;
  background-color: #6e8efb;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.modal-ok-btn:hover {
  background-color: #5a7df4;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .problem-report-card {
    padding: 20px;
    margin: 10px;
  }
  
  .priority-options {
    flex-direction: column;
    gap: 8px;
  }
  
  .priority-btn {
    width: 100%;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .cancel-btn, .submit-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .file-upload {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .upload-btn, .clear-btn {
    width: 100%;
  }
}
</style>